import React, { useState, useRef, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { people } from "../../data/peopleData";
import "./personDetail.css";

const PersonDetail = () => {
  const { name } = useParams();
  const location = useLocation();
  const person = people.find((p) => p.slug === name.toLowerCase());

  const [selectedMediaIndex, setSelectedMediaIndex] = useState(null);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const videoRef = useRef(null);

  const isFromDirectorsPage = person && location.pathname.includes("/directors");
  const mediaArray = person ? (isFromDirectorsPage ? person.videos : person.images) : [];

  // Klavyenin yön tuşlarıyla gezinme
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedMediaIndex !== null) {
        if (e.key === "ArrowRight") {
          handleNext();
        } else if (e.key === "ArrowLeft") {
          handlePrev();
        } else if (e.key === "Escape") {
          handleClose();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [selectedMediaIndex]);

  if (!person) {
    return <div className="person-not-found">Person not found.</div>;
  }

  const handleNext = () => {
    if (selectedMediaIndex !== null) {
      setSelectedMediaIndex((prevIndex) =>
        prevIndex === mediaArray.length - 1 ? 0 : prevIndex + 1
      );
    }
  };

  const handlePrev = () => {
    if (selectedMediaIndex !== null) {
      setSelectedMediaIndex((prevIndex) =>
        prevIndex === 0 ? mediaArray.length - 1 : prevIndex - 1
      );
    }
  };

  const handleClose = () => {
    setSelectedMediaIndex(null);
    setIsVideoPlaying(false);
  };

  const handleVideoPlay = () => {
    setIsVideoPlaying(true);
  };

  // Boş alana tıklayınca modalı kapatma
  const handleModalClick = (e) => {
    if (e.target.classList.contains("modal")) {
      handleClose();
    }
  };

  // YouTube video ID'sini çıkar
  const getYouTubeVideoId = (url) => {
    const match = url.match(/[?&]v=([^&]+)/);
    return match ? match[1] : null;
  };

  // Vimeo video ID'sini çıkar
  const getVimeoVideoId = (url) => {
    const match = url.match(/vimeo.com\/(\d+)/);
    return match ? match[1] : null;
  };

  // Video platformunu kontrol et
  const getVideoPlatform = (url) => {
    if (url.includes("vimeo.com")) return "vimeo";
    if (url.includes("youtube.com") || url.includes("youtu.be")) return "youtube";
    return null;
  };

  return (
    <div className="person-detail">
      <h1 className="person-name">{person.name}</h1>
      <div className="person-gallery">
        {mediaArray.map((media, index) => (
          <div key={index} className="media-thumbnail" onClick={() => setSelectedMediaIndex(index)}>
            {isFromDirectorsPage ? (
              <div className="video-thumbnail-wrapper">
                {getVideoPlatform(media) === "vimeo" ? (
                  <img src={`https://vumbnail.com/${getVimeoVideoId(media)}.jpg`} alt={person.name} className="person-thumbnail" />
                ) : getVideoPlatform(media) === "youtube" ? (
                  <img src={`https://img.youtube.com/vi/${getYouTubeVideoId(media)}/0.jpg`} alt={person.name} className="person-thumbnail" />
                ) : null}
                <div className="play-icon">▶</div>
              </div>
            ) : (
              <img src={media} alt={person.name} className="person-thumbnail" />
            )}
          </div>
        ))}
      </div>
      <p className="person-description">{person.description}</p>

      {selectedMediaIndex !== null && (
        <div className="modal" onClick={handleModalClick}>
          <button className="close-button" onClick={handleClose}>✕</button>
          <button className={`prev-button ${isFromDirectorsPage ? "video-nav" : ""}`} onClick={handlePrev}>◀</button>
          {isFromDirectorsPage ? (
            <>
              {getVideoPlatform(mediaArray[selectedMediaIndex]) === "vimeo" ? (
                <iframe
                  ref={videoRef}
                  src={`https://player.vimeo.com/video/${getVimeoVideoId(mediaArray[selectedMediaIndex])}`}
                  width="800"
                  height="450"
                  frameBorder="0"
                  allow="autoplay; fullscreen"
                  title="Selected Video"
                  className="modal-video"
                  onPlay={handleVideoPlay}
                ></iframe>
              ) : getVideoPlatform(mediaArray[selectedMediaIndex]) === "youtube" ? (
                <iframe
                  ref={videoRef}
                  src={`https://www.youtube.com/embed/${getYouTubeVideoId(mediaArray[selectedMediaIndex])}`}
                  width="800"
                  height="450"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Selected Video"
                  className="modal-video"
                  onPlay={handleVideoPlay}
                ></iframe>
              ) : null}
            </>
          ) : (
            <img src={mediaArray[selectedMediaIndex]} alt="Selected" className="modal-image" />
          )}
          <button className={`next-button ${isFromDirectorsPage ? "video-nav" : ""}`} onClick={handleNext}>▶</button>
        </div>
      )}
    </div>
  );
};

export default PersonDetail;
